export var ChartingItemType;
(function (ChartingItemType) {
    ChartingItemType["CHECKLIST"] = "checklist";
    ChartingItemType["DATE"] = "date";
    ChartingItemType["FILES"] = "files";
    ChartingItemType["GROUP"] = "group";
    ChartingItemType["NOTES"] = "notes";
    ChartingItemType["RESULTS"] = "results";
    ChartingItemType["SELECT"] = "select";
    ChartingItemType["TEXT"] = "text";
})(ChartingItemType || (ChartingItemType = {}));
export var ChartingSelectType;
(function (ChartingSelectType) {
    ChartingSelectType["TEXT_BOX_PICKER_HORIZONTAL"] = "textBoxPickerHorizontal";
    ChartingSelectType["TEXT_BOX_PICKER_VERTICAL"] = "textBoxPickerVertical";
})(ChartingSelectType || (ChartingSelectType = {}));
/**
 * IDs of charting items that are related to failure, which have special logic behind them
 */
export var ChartingFailureRelatedIDs;
(function (ChartingFailureRelatedIDs) {
    /** id for specifying no failure, failure, or partial failure */
    ChartingFailureRelatedIDs["CHARTING_FAILURE"] = "chartingFailure";
    /** id for charting item of type group that contains:
     * CHARTING_FAILURE_REASON_VERSION
     * CHARTING_FAILURE_REASON_SPECIFY_SUPPLY
     * CHARTING_FAILURE_REASON_SPECIFY_VENIPUNCTURE
     */
    ChartingFailureRelatedIDs["CHARTING_FAILURE_REASON"] = "chartingFailureReason";
    /** id for failure reason version (supply vs venipuncture issue) */
    ChartingFailureRelatedIDs["CHARTING_FAILURE_REASON_VERSION"] = "chartingFailureReasonVersion";
    /** id for supply-specific failure details */
    ChartingFailureRelatedIDs["CHARTING_FAILURE_REASON_SPECIFY_SUPPLY"] = "chartingFailureReasonSpecifySupply";
    /** id for venipuncture-specific failure details */
    ChartingFailureRelatedIDs["CHARTING_FAILURE_REASON_SPECIFY_VENIPUNCTURE"] = "chartingFailureReasonSpecifyVenipuncture";
})(ChartingFailureRelatedIDs || (ChartingFailureRelatedIDs = {}));
// Special ID for tube labeling check
export const CHARTING_TUBE_LABELING_CHECK_ID = 'chartingTubeLabelingCheck';
export var ChartingRequiredCondition;
(function (ChartingRequiredCondition) {
    /** Field is required */
    ChartingRequiredCondition["TRUE"] = "true";
    /** Field is optional */
    ChartingRequiredCondition["FALSE"] = "false";
    /** Field is optional, but charting notes must be provided if field is
     * filled */
    ChartingRequiredCondition["CHART_IF_TRUE"] = "chartIfTrue";
    /** Field is optional, but charting notes must be provided if field is not
     * filled */
    ChartingRequiredCondition["CHART_IF_FALSE"] = "chartIfFalse";
})(ChartingRequiredCondition || (ChartingRequiredCondition = {}));
export var ChartingStatus;
(function (ChartingStatus) {
    /** Charting not yet completed */
    ChartingStatus["PENDING"] = "pending";
    /** Charting has been completed */
    ChartingStatus["COMPLETE"] = "complete";
})(ChartingStatus || (ChartingStatus = {}));
//# sourceMappingURL=charting.js.map